import {http} from "../../api/player";
import tokenStorage from "./tokenStorage";

export * from "../../api/player";
export {http};

export const HEADER_CLIENT_ACCESS_TOKEN = 'x-client-access-token';

http.interceptors.request.use((config) => {
    const token = tokenStorage.get();
    if (token) {
        config.headers[HEADER_CLIENT_ACCESS_TOKEN] = token;
    }

    return config;
});

http.interceptors.response.use(
    response => {
        handleClientAccessToken(response);

        return response;
    },
    error => {
        if (error.response) {
            handleClientAccessToken(error.response);
        }

        return Promise.reject(error);
    }
);

const handleClientAccessToken = (response) => {
    if (!response.headers.hasOwnProperty(HEADER_CLIENT_ACCESS_TOKEN)) {
        return;
    }

    const token = response.headers[HEADER_CLIENT_ACCESS_TOKEN];

    tokenStorage.set(token);
}
